"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClickEventType = void 0;
var ClickEventType;
(function (ClickEventType) {
    ClickEventType["CLICK"] = "Click";
    ClickEventType["BUTTON_CLICK"] = "ButtonClick";
    ClickEventType["ICON_CLICK"] = "IconClick";
    ClickEventType["TEXT_CLICK"] = "TextClick";
    ClickEventType["BOX_CLICK"] = "BoxClick";
    ClickEventType["RADIO_BUTTON_CLICK"] = "RadioButtonClick";
    ClickEventType["OPEN_ACCORDION"] = "OpenAccordion";
    ClickEventType["CLOSE_ACCORDION"] = "CloseAccordion";
})(ClickEventType || (exports.ClickEventType = ClickEventType = {}));
//# sourceMappingURL=ClickEventType.js.map